<template>
<div class="checkmark"></div>
</template>

<script>
export default {
name: "Checkmark",
}
</script>

<style scoped>
.checkmark {
  position: absolute;
  display:inline-block;
  width: 22px;
  height:22px;
  background: #047857;
  border-radius:50%;
  transform: rotate(45deg);
}

.checkmark:before{
  content:"";
  position: absolute;
  width:3px;
  height:9px;
  background-color:#fff;
  left:11px;
  top:6px;
}

.checkmark:after{
  content:"";
  position: absolute;
  width:3px;
  height:3px;
  background-color:#fff;
  left:8px;
  top:12px;
}

</style>